document.addEventListener('DOMContentLoaded', () => {
  function updateRate() {
    const rateSpan = document.getElementById('rateAmount');
    const priceList = document.querySelector('price-list');
    if (!rateSpan || !priceList) return;

    const price = parseFloat(priceList.getAttribute('data-price'));
    if (!price || isNaN(price)) {
      rateSpan.textContent = 'N/A';
      return;
    }

    let rate = (price / 3).toFixed(2);
    if (document.documentElement.lang === 'it') {
      rate = rate.replace('.', ',');
    }
    rateSpan.textContent = rate;
  }

  updateRate();
  document.addEventListener('variant:change', updateRate);

  const priceList = document.querySelector('price-list');
  if (priceList) {
    const observer = new MutationObserver(updateRate);
    observer.observe(priceList, {
      attributes: true,
      attributeFilter: ['data-price']
    });
  }
});
